import { useTheme } from 'next-themes';
import { ComponentProps } from 'react';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toaster]:text-muted-foreground',
          actionButton:
            'group-[.toaster]:bg-primary group-[.toaster]:text-primary-foreground',
          cancelButton:
            'group-[.toaster]:bg-muted group-[.toaster]:text-muted-foreground',
          info: 'group-[.toaster]:text-foreground',
          success:
            'group-[.toaster]:bg-success group-[.toaster]:text-success-foreground',
          error:
            'group-[.toaster]:bg-error group-[.toaster]:text-error-foreground',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
